import axios from 'axios';
import uuid from 'react-uuid'
import CryptoJS from 'crypto-js';
import Base64 from 'crypto-js/enc-base64';
import { s360ConfigService } from './S360Config';

class APIService {

    constructor() {
        if (!APIService.shared) { APIService.shared = this; }
        return APIService.shared;
    }

    logInWithFormData = (formDetails)   => { return this.logIn({"form": formDetails   }); }
    logInWithUserData = (chatUserModel) => { return this.logIn({"user": chatUserModel }); }

    logIn = (data) => {
         // Private Method
        const url         = "https://" + s360ConfigService.config.host + "/bmapi/jabber/login";
        const nonce       = uuid();
        const timestamp   = new Date().getTime();
        const bearerToken = this.generateBearerToken(url, nonce, timestamp);
        const config      = { headers: { Authorization: bearerToken, "content-type": "application/json" }, params: { nonce: nonce, timestamp: timestamp } }

        data["configId"] = s360ConfigService.config.configId;
        data["host"]     = s360ConfigService.config.host;
        return axios.post(url, data, config);
    }

    uploadMedia = (fileToUpload, mediaType) => {
        const url         = "https://" + s360ConfigService.config.host + "/bmapi/jabber/upload";
        const nonce       = uuid();
        const timestamp   = new Date().getTime();
        const bearerToken = this.generateBearerToken(url, nonce, timestamp, mediaType);
        const config      = { headers: { Authorization: bearerToken, "content-type": "multipart/form-data" }, params:  { nonce: nonce, timestamp: timestamp } }
        if (mediaType) { config.params.type = mediaType; }
        const formData = new FormData();
        formData.append('file', fileToUpload)
        return axios.post(url, formData, config);
    }

    // Private Method, Tested, Working.
    generateBearerToken = (serviceUrl, nonce, timestamp, mediaType) => {
        let dataString = "POST&" + encodeURIComponent(serviceUrl) + "&" + encodeURIComponent("nonce=" + nonce )+ encodeURIComponent("&timestamp=" + timestamp);
        if (mediaType) { dataString += encodeURIComponent("&type=" + mediaType) }

        let sha1Signature    = CryptoJS.HmacSHA1(dataString, s360ConfigService.config.token);
        let encodedSignature = Base64.stringify(sha1Signature);

        return "Bearer " + encodedSignature;
    }

}

var apiService = new APIService();
export default apiService;